import React, { useState } from "react";
import { MUSCLE_GROUP_LABELS, ExerciseDetails } from "../../api/types.ts";
import { getMuscleGroupIcon } from "../../util/muscleGroupIcons.ts";
import { RxQuestionMarkCircled } from "react-icons/rx";

import { IoIosArrowDown } from "react-icons/io";
import { Tooltip } from "../widgets/Tooltip.tsx";
import { totalPowerPoints } from "../../util/exercise.tsx";
import { WorkoutExerciseSets } from "../workouts/WorkoutExerciseSets.tsx";

const ActivityExerciseIcon = ({ exercise }: { exercise: ExerciseDetails }) => {
  const Icon = getMuscleGroupIcon(
    exercise.primary_muscle_groups.map((muscle) => muscle.muscle_group),
  );
  return <Icon className="text-gray-600" size={20} />;
};

const ActivityExerciseCard = ({ exercise }: { exercise: ExerciseDetails }) => {
  const [showExerciseDetails, setShowExerciseDetails] = useState(false);
  const [showToolTip, setShowToolTip] = useState(false);

  return (
    <div className="bg-gray-50 rounded-md p-3">
      <div className="flex flex-row items-center gap-2 flex-1">
        <ActivityExerciseIcon exercise={exercise} />
        <h5 className="text-gray-800 font-semibold p-2">{exercise.name}</h5>
      </div>
      <WorkoutExerciseSets exercise={exercise} />
      <div
        className="w-full text-gray-600 flex flex-row mt-2"
        aria-label="Show performance details"
      >
        <IoIosArrowDown
          className="inline-block transition-transform duration-300"
          style={{
            transform: showExerciseDetails ? "rotate(180deg)" : "rotate(0deg)",
          }}
          onClick={() => setShowExerciseDetails((prev) => !prev)}
        />
        <div
          className={`${showExerciseDetails ? "border-b-2" : ""} w-full mb-2 mx-2`}
        />
      </div>
      {showExerciseDetails && (
        <div className="mt-2 flex flex-col">
          <div
            className="flex w-min"
            onMouseEnter={() => setShowToolTip(true)}
            onMouseLeave={() => setShowToolTip(false)}
          >
            <Tooltip
              show={showToolTip}
              label="The Performance Points are an accumulation of the total sets and the muscle group weights defined in the exercise."
              alignRight
            >
              <div className="flex flex-row gap-1">
                <span className="text-xs mb-1">Performance</span>
                <RxQuestionMarkCircled className="p-0.5 text-gray-600" />
              </div>
            </Tooltip>
          </div>
          {exercise.primary_muscle_groups.map((muscle) => (
            <span className="text-xs text-gray-600">
              <span className="font-bold">
                {MUSCLE_GROUP_LABELS[muscle.muscle_group]}
              </span>
              : {Math.round(totalPowerPoints(exercise) * muscle.weight)} points
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

interface ActivityExerciseListProps {
  resourceId: string;
  activityExercises: ExerciseDetails[];
}

const ActivityExerciseList: React.FC<ActivityExerciseListProps> = ({
  resourceId,
  activityExercises,
}) => {
  return (
    <div key={resourceId} className="space-y-3">
      {activityExercises.map((ExerciseDetails, index) => (
        <div key={`${resourceId}-${index}`}>
          <ActivityExerciseCard exercise={ExerciseDetails} />
        </div>
      ))}
    </div>
  );
};

export { ActivityExerciseList };
